import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'NEWS', path: '/news' },
  { label: 'PATCH NOTES', path: '/patch-notes' },
  { label: 'ABOUT', path: '/about' },
  { label: 'CONTACT', path: '/contact' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0d0d0d] border-b border-[#222]">
      <div className="flex items-center h-14 px-6">
        {/* Hamburger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          className="w-8 h-8 flex items-center justify-center text-white hover:text-[#00ff41] transition-colors cursor-pointer mr-4 shrink-0"
        >
          <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>

        {/* Logo */}
        <Link to="/" className="flex items-center gap-0 cursor-pointer shrink-0 mr-8">
          <span className="font-['Barlow_Condensed'] font-black text-white text-xl tracking-tight leading-none">
            CALL<span className="text-[#999]">OF</span>DUTY
          </span>
          <span className="font-['Barlow_Condensed'] font-black text-[#00ff41] text-xl tracking-tight leading-none ml-1">
            NEXT
          </span>
        </Link>

        {/* Divider */}
        <div className="hidden md:block w-px h-5 bg-[#333] mr-8" />

        {/* Nav Links */}
        <nav className="hidden md:flex items-center gap-6 flex-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-['Barlow_Condensed'] font-bold text-sm tracking-widest transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-white'
                  : 'text-[#888] hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right: Subscribe CTA */}
        <div className="ml-auto hidden md:flex items-center gap-4">
          <a
            href="/newsletter"
            className="font-['Barlow_Condensed'] font-black text-sm tracking-widest bg-[#00ff41] text-black px-5 py-2 hover:bg-[#00e63a] transition-colors cursor-pointer whitespace-nowrap"
          >
            SUBSCRIBE
          </a>
        </div>

        {/* Mobile right */}
        <div className="ml-auto md:hidden">
          <a
            href="/newsletter"
            className="font-['Barlow_Condensed'] font-black text-xs tracking-wider bg-[#00ff41] text-black px-3 py-1.5 cursor-pointer whitespace-nowrap"
          >
            SUBSCRIBE
          </a>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#111] border-t border-[#222] px-6 py-5 flex flex-col gap-1">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className="font-['Barlow_Condensed'] font-bold text-sm tracking-widest text-[#888] hover:text-white py-2 border-b border-[#1a1a1a] cursor-pointer"
          >
            HOME
          </Link>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`font-['Barlow_Condensed'] font-bold text-sm tracking-widest py-2 border-b border-[#1a1a1a] cursor-pointer ${
                location.pathname === link.path ? 'text-white' : 'text-[#888] hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
